import { ethers } from 'ethers'; // <-- Import ethers
import { defineChain } from 'viem';

const BSCMAINNET = defineChain({
  id: 56,
  name: 'BSC Mainnet',
  nativeCurrency: { name: 'BSC Mainnet', symbol: 'BNB', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://bsc-dataseed.binance.org'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Bscscan',
      url: 'https://bscscan.com',
    },
  },
})
// const BSCTESTNET = defineChain({
//   id: 97,
//   name: 'BSC Testnet',
//   nativeCurrency: { name: 'BSC Testnet', symbol: 'TBNB', decimals: 18 },
//   rpcUrls: {
//     default: {
//       http: ['https://data-seed-prebsc-1-s1.binance.org:8545/'],
//     },
//   },
//   blockExplorers: {
//     default: {
//       name: 'Bscscan',
//       url: 'https://testnet.bscscan.com/',
//     },
//   },
// })
// const AARMAMAINNET = defineChain({
//   id: 2889,
//   name: 'Aarma Mainnet',
//   nativeCurrency: { name: 'Aarma Mainnet', symbol: 'ARMA', decimals: 18 },
//   rpcUrls: {
//     default: {
//       http: ['https://aarmarpc.com'],
//     },
//   },
//   blockExplorers: {
//     default: {
//       name: 'Aarmascan',
//       url: 'https://aarmascan.com',
//     },
//   },
// })

export const chains = [BSCMAINNET]